import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateRecentCalls = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 559.7 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#ebf3ff;}.d{fill:#fafcff;}.e,.f{fill:#9ec5ff;}.g{fill:#dcebfe;}.h{opacity:.15;}.f{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "g",
				d: "M383.11,345.34c-.08-.28-.17-.56-.28-.82,19.72-27.54,31.33-61.27,31.33-97.73,0-92.8-75.23-168.02-168.02-168.02S78.12,153.99,78.12,246.79s75.23,168.02,168.02,168.02c36.22,0,69.76-11.46,97.2-30.95l43.44,25.61c5.85,3.45,12.94-1.93,11.18-8.49l-14.86-55.64Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "f",
				d: "M331.22,288.1l-36.73-18.86c-1.49-.5-3.47-.5-4.96,.99l-14.89,14.89c-1.49,1.49-2.98,1.99-4.96,.99-22.83-10.42-46.65-34.24-57.57-57.57-.5-1.49,0-2.98,.99-4.47l15.38-15.38c.99-.99,1.49-2.98,.5-4.47l-18.86-36.73c-.99-2.48-3.47-2.98-5.46-1.99-8.44,4.47-15.38,9.93-20.84,15.88-11.91,12.9-14.89,29.78-8.93,45.66,17.87,47.15,49.63,78.91,96.77,96.77,15.88,5.96,32.76,2.48,45.66-8.93,5.96-5.46,11.41-12.41,15.88-20.84,.99-1.99,0-4.47-1.99-5.96h0Z"
			})] }), /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("circle", {
					className: "h",
					cx: 387.6,
					cy: 142.24,
					r: 51.18
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "e",
					cx: 390.73,
					cy: 137.93,
					r: 51.18
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M414.88,123.62c.05,1.12-.37,2.22-1.16,3.01l-28.09,28.09c-.71,.71-1.62,1.21-2.62,1.29-1.19,.1-2.33-.32-3.16-1.15l-12.1-12.1c-.79-.79-1.22-1.89-1.16-3.01,.05-1.12,.58-2.17,1.45-2.89,1.56-1.29,3.96-1.14,5.45,.35l9.12,9.12s.1,.04,.14,0l25.25-25.25c1.49-1.49,3.88-1.64,5.45-.35,.87,.72,1.39,1.77,1.45,2.9Z"
				})
			] })]
		})
	]
});
export default SvgEmptyStateRecentCalls;
